module.exports = __webpack_public_path__ + "static/img/14000664.4024d601.png";